
export const ABOUT_START = "Hello!";
export const ABOUT_START2 = "I am ";
export const ABOUT_TITLE = "Full stack software developer";
export const ABOUT_LOCATION = "based in Canada";
export const _BUL = "• ";
export const ABOUT_NAME = "Abbas Olfat";
export const ABOUT_SUMMERY =
  "I am an experienced Software Engineer with strong expertise in designing, developing, debugging, and optimizing both backend and frontend applications. Proficient in C#, ASP.NET, JavaScript, React, SQL databases, using Azure cloud platform and highly motivated to learn new technologies, with experience collaborating both small and large teams across multiple projects and organizations.";

export const ABOUT_SERVICES = [
  "Create modern, secure, scalable, and high-performance software applications tailored to your unique needs, including front-end and back-end development using React and C# ASP.NET technologies.",
  "Build reliable microservices and RESTful back-end APIs that support web and mobile applications.",
  "Optimize web and desktop applications for maximum speed and scalability by identifying and resolving performance bottlenecks.",
  "Manage and deploy application components on cloud platforms.",
];
export const ABOUT_TYPE_ANIMATION_DELAY = 4000;
export const FOOTER_TEXT="Designed & Developed by Abbas Olfat © 2024";
export const NAVBAR_LINKS_EMAIL="mailto:abas.olfat@yahoo.com";
export const NAVBAR_LINKS_GIT="https://github.com/abas1200";
export const NAVBAR_LINKS_LINKDIN="https://www.linkedin.com/in/abas-olfat";

/////////////////////////////////////Settings//////////////////////////////////////////
export const NAVBAR_MENU_ITEMS = [
  {
    name: "home",
    text: "Home",
  },
  {
    name: "about",
    text: "About",
  },
  //   {
  //     name: "skills",
  //     text: "Skills",
  //   },
  {
    name: "resume",
    text: "Resume",
  },
  //   {
  //     name: "works",
  //     text: "Works",
  //   },
  {
    name: "contact",
    text: "Contact",
  },
];

export const SKILL_ITEMS = [
  {
    text: "C# .Net",
    url: "skills-icons/c-sharp.svg",
  },
  {
    text: "ASP.NET MVC/Core",
    url: "skills-icons/aspdotnet.svg",
  },
  {
    text: "ReactJs/TypeScript",
    url: "skills-icons/react.svg",
  },
  {
    text: "JavaScript",
    url: "skills-icons/javascript.svg",
  },
  {
    text: "NodeJS",
    url: "skills-icons/nodejs.svg",
  },
  {
    text: "SQL Server Database",
    url: "skills-icons/sql-database-generic.svg",
  },
  {
    text: "Docker",
    url: "skills-icons/docker.svg",
  },
  {
    text: "Microsoft Azure",
    url: "skills-icons/microsoft-azure.svg",
  },
  {
    text: "Python",
    url: "skills-icons/python-logo.png",
  },
];

export const SKILLS_PROGRESS = [
  {
    title: "C#/ASP.NET/Python",
    percent: "100",
  },
  {
    title: "ReactJS/TypeScript/JQuery/JavaScript",
    percent: "100",
  },
  {
    title: "HTML/CSS/Bootstrap",
    percent: "100",
  },
  {
    title: "T-SQL/SQLSERVER/MongoDB/PostgreSQL/MYSQL",
    percent: "100",
  },
  {
    title: "Azure/Docker",
    percent: "100",
  },
];

export const RESUME_EDUCATION = [
  {
    title: "Master of Engineering (MEng) Information System Security",
    description:"GPA - (3.76/4.3)",
    organization: "Concordia University",
    link:"https://www.concordia.ca/",
    start: "2019",
    end: "2021",
    location:"Montreal, Quebec, Canada"
  },
  {
    title: "Bachelor's Degree in Computer Software Engineering",
    description:"",
    organization: "Razi University",
    link:"https://en.razi.ac.ir/",
    start: "2008",
    end: "2012",
  },
];

export const RESUME_EXPERIENCE = [
  {
    title: "Full Stack Developer",
    description:"Developing secure, scalable, high-performance cloud-based web applications with AI integration.",
    organization: "ISB Global Services",
    link:"https://www.isbglobalservices.com",
    start: "03/2025",
    end: "Present",
    location:"Ontario, Canada"
  },
  {
    title: "Full Stack Developer (.NET/React)",
    description:"Designed and developed secure, scalable, high-performance cloud-based payment processing applications.",
    organization: "Nuvei Technologies",
    link:"https://nuvei.com/",
    start: "05/2021",
    end: "09/2023",
    location:"Montreal, Quebec, Canada"
  },
  {
    title: "Senior Full Stack .NET Developer",
    description:"Designed and Developed custom web and desktop applications based on user requests.",
    organization: "DPardazan Novin & PSoft",
    link:"https://darupardazan.com/",
    start: "01/2013",
    end: "03/2019",
    location:"Tehran, Iran"
  }
];